import React, {useState, useEffect, useContext} from 'react';
import {styled, createTheme, ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import {Context as FinancialContext} from '../../contexts/FinancialContext';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import Profile from '../FinancialManager/Profile';
import Goals from '../FinancialManager/Goals';
import {useIntercom} from 'react-use-intercom';
import HomeDrawer from '../../components/Common/HomeDrawer';
import {Context as AuthContext} from '../../contexts/AuthContext';

const PFMHome = ({}) => {
  const navigate = useNavigate();
  const {state: route} = useLocation();
  const {boot, shutdown, hide, show, update} = useIntercom();

  const {
    state: {uid},
  } = useContext(AuthContext);

  const [index, setIndex] = useState(route && route.index ? route.index : 3);
  const [loaded, setLoaded] = useState(false);

  //TODO:  INTERCOM why issues
  // const INTERCOM_APP_ID = 'ww60whap';
  // window.Intercom('shutdown');
  // window.Intercom('boot', {
  //   app_id: INTERCOM_APP_ID,
  // });

  const {fetchInitial} = useContext(FinancialContext);

  useEffect(() => {
    if (!loaded) {
      fetchInitial(uid);
      setLoaded(true);
    }
  }, []);

  return (
    <>
      <Box sx={{display: 'flex', minWidth: '1400px'}}>
        <CssBaseline />
        <HomeDrawer index={index} setIndex={setIndex} product="pfm" />
        {index === 3 && <Profile />}
        {index === 4 && <Goals />}
      </Box>
    </>
  );
};

export default PFMHome;
